import { Component } from "react";
import { connect } from "react-redux";
import WorkOrderCard from "../../Interventions/WorkOrderCard";
import WorkOrdersFilters from "../../Interventions/WorkOrdersFilters";
import { ALL_SELECT_OPTION } from "../../../constants";

class CustomerWorkOrdersTab extends Component {
    render() {
        let workOrdersElements = [];
        this.props.workOrders
            .filter((wo) => {
                let technicianOk =
                    wo.technicians.includes(this.props.interventionsFilters.selectedTechnicianId) ||
                    this.props.interventionsFilters.selectedTechnicianId === ALL_SELECT_OPTION;

                let cerfaOk = this.props.interventionsFilters.displayOnlyIfGotCerfa ? wo.has_liquid_file : true;

                return technicianOk && cerfaOk;
            })
            .forEach((workOrder, i) => {
                workOrdersElements.push(<WorkOrderCard key={i} currentWorkOrder={workOrder} />);
            });

        return (
            <div className="col-lg-12 col-md-12 col-sm-12 col-12 without-side-margin row without-side-padding">
                <WorkOrdersFilters allWorkOrders={this.props.workOrders} />
                {workOrdersElements}
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        interventionsFilters: state.interventions,
    };
};

const mapDispatchToProps = () => {
    return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(CustomerWorkOrdersTab);
